module.exports = __webpack_public_path__ + "media/img/home/product/product1-490d8d8865e2cb77410188a4a4f87206.svg";